import React, { useState, useEffect, useContext } from "react";
import UserDelagateAppSurveyReadOnlyRow from "./UserDelagateAppSurveyReadOnlyRow";
import UserDelegateAppSurveyTableRow from "./UserDelegateAppSurveyTableRow";
import UserContext from "../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import FetchUtil from "../utils/FetchUtil";
import "../css/ListUsers.css";
import { useNavigate } from "react-router-dom";


function UserDelegateAppSurveyTable({ key, setDelegateAppSurvey, loginId, companyId }) {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [add, setAdd] = useState(false);
	const [edit, setEdit] = useState(false);
	const [addRowTop, setAddRowTop] = useState(false);
	const [addRowBottom, setAddRowBottom] = useState(false);
	const [error, setError] = useState("");
	const [isUserDelegateAppSurveyLoading, setIsUserDelegateAppSurveyLoading] = useState(false);
	const [userDelegateAppSurveys, setUserDelegateAppSurveys] = useState([]);
	const [isUserDelegateLoading, setIsUserDelegateLoading] = useState(false);
	const [userDelegates, setUserDelegates] = useState([]);
	const [count, setCount] = useState(0);
	const closeText = t("page.close");
	const userCtx = useContext(UserContext);

	const initialValues = {
		loginId: loginId,
		companyId: companyId,
		delegateCompanyId: 0,
		appSurveyKey: 0,
		canRead: false,
		canWrite: false,
		canReview: false,
	};
	const [formValues, setFormValues] = useState(initialValues);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	let userCompanyId = userCtx.userCompanyId;
	useEffect(() => {
		fetchUserDelegates();
		fetchUserDelegateAppSurveys();
	}, []);

	const handleClose = (event) => {
		setDelegateAppSurvey(false);
	};


	function fetchUserDelegates() {
		if (companyId === 0 || !loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateLoading(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web",
				getAll: false,
				companyId: companyId,
				loginId: loginId
			}),
		};
		try {
			FetchUtil.fetchAPI("MGetUserDelegates", "/Service/UserService/GetUserDelegates", requestOptions, getUserDelegatesSuccess, getUserDelegatesFail);
		} catch (error) {
			setIsUserDelegateLoading(false);
			throw new Error(error.message);
		}
	}

	function getUserDelegatesFail(redirect) {
		setIsUserDelegateLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.userDelegateNotRetrieved"));
	}

	function getUserDelegatesSuccess(responseData) {
		let userDelegatesResponse;
		setUserDelegates([]);
		if (responseData) {
			userDelegatesResponse = responseData.getUserDelegatesResponse;
			if (userDelegatesResponse && userDelegatesResponse.errorCode === "0") {
				setUserDelegates([...userDelegatesResponse.delegates]);
			} else if (userDelegatesResponse && userDelegatesResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (userDelegatesResponse) {
				setError(t("error.error") + " " + userDelegatesResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateLoading(false);
	}



	function fetchUserDelegateAppSurveys() {
		setError("");
		if (!initialValues.companyId || initialValues.companyId === 0 || !initialValues.loginId) {
			return;
		}
		resetCounter();
		setIsUserDelegateAppSurveyLoading(true);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: true, companyId: initialValues.companyId,
				loginId: initialValues.loginId, userCompanyId: userCompanyId
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserDelegateAppSurvey", "/Service/UserService/GetUserDelegateAppSurvey", requestOptions, retrieveDelegateAppSurveySuccess, retrieveDelegateAppSurveyFail);
		} catch (error) {
			setIsUserDelegateAppSurveyLoading(false);
			throw new Error(error.message);
		}
	}

	function retrieveDelegateAppSurveyFail(redirect) {
		setIsUserDelegateAppSurveyLoading(false);
		if (redirect) {
			navigate("/");
		}
		setError(t("error.delegateGetAppSurveyFailed"));
	}

	function retrieveDelegateAppSurveySuccess(responseData) {
		let fetchUserDelegateAppSurveysResponse;
		if (responseData) {
			fetchUserDelegateAppSurveysResponse = responseData.getUserDelegateAppSurveysResponse;
			if (fetchUserDelegateAppSurveysResponse && fetchUserDelegateAppSurveysResponse.errorCode === "0") {
				setUserDelegateAppSurveys(fetchUserDelegateAppSurveysResponse.appSurveys.slice())
			} else if (fetchUserDelegateAppSurveysResponse && fetchUserDelegateAppSurveysResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserDelegateAppSurveysResponse) {
				setError(t("error.error") + " " + fetchUserDelegateAppSurveysResponse.errorMessage);
			} else {
				setError(t("error.system.fetch"));
			}
		}
		setIsUserDelegateAppSurveyLoading(false);
	}

	const addRowTableTop = () => {
		setAddRowTop(true);
		setAddRowBottom(false);
		addRowTable();
	};

	const addRowTableBottom = () => {
		setAddRowTop(false);
		setAddRowBottom(true);
		addRowTable();
	};

	const addRowTable = () => {
		setError("");
		if (!add && !edit) {
			setAdd(true);
		} else {
			if (add) {
				setError(t("error.only1RowAllowed"));
			} else if (edit) {
				setError(t("error.onlyEditAllowed"));
			}
		}

	};

	const removeRowTable = () => {
		setError("");
		resetRowTable();
	};
	const resetRowTable = () => {
		setAddRowTop(false);
		setAddRowBottom(false);
		setAdd(false);
		setEdit(false);
	};
	const handleDeleteClick = (event, userDelegateItem, completeCallback) => {
		event.preventDefault();
		deleteUserDelegateAppSurvey(userDelegateItem, completeCallback);
	};
	const deleteUserDelegateAppSurvey = (userDelegateItem, completeCallback) => {
		let action = 3;
		if (userDelegateItem.statusCode === 1) {
			action = 4;
		}
		let serverParams = {
			userDelegateSurveyKey: userDelegateItem.userDelegateSurveyKey,
			loginId: initialValues.loginId,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("DeleteUserDelegateAppSurvey", "/Service/UserService/DeleteUserDelegateAppSurvey", requestOptions, deleteDelegateAppSurveySuccess, deleteDelegateAppSurveyFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function deleteDelegateAppSurveyFail(redirect, completeCallback) {
		setError(t("error.userAppSurveyEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function deleteDelegateAppSurveySuccess(responseData, completeCallback) {
		let deleteUserDelegateAppSurveyResponse;
		if (responseData) {
			deleteUserDelegateAppSurveyResponse = responseData.deleteUserDelegateAppSurveyResponse;
			if (deleteUserDelegateAppSurveyResponse) {
				if (deleteUserDelegateAppSurveyResponse.errorCode === "0") {
					resetRowTable();
					refreshUserDelegateAppSurvey();
				} else {
					setError(t("error.error") + " " +
						deleteUserDelegateAppSurveyResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}

	const handleSubmit = (action, setValues, completeCallback) => {
		setError("");
		let found = false;
		if (!formValues.loginId) {
			setError(t("error.userReqd"));
			if (completeCallback) {
				completeCallback();
			}
			return false;
		}
		if (action === 1) {
			if (userDelegateAppSurveys.length > 0) {
				userDelegateAppSurveys.map((delegateAppSurveyItem, index) => {
					if (delegateAppSurveyItem.appSurveyKey === setValues.appSurveyKey && 
						delegateAppSurveyItem.delegateCompanyId === setValues.delegateCompanyId && 
						delegateAppSurveyItem.userDelegateKey == setValues.userDelegateKey &&
						delegateAppSurveyItem.buyerKey == setValues.buyerKey &&
						delegateAppSurveyItem.indirectBuyerKey == companyId){
						setError(t("error.userAppSurveyDup"));
						found = true;
						if (completeCallback) {
							completeCallback();
						}
						return false;
					}
				})
			}
			if (!found) {
				saveUserDelegateAppSurvey(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (action === 2) {
			if (userDelegateAppSurveys.length > 0) {
				userDelegateAppSurveys.map((delegateAppSurveyItem, index) => {
					if (delegateAppSurveyItem.appSurveyKey === setValues.appSurveyKey && 
						delegateAppSurveyItem.delegateCompanyId === setValues.delegateCompanyId && 
						delegateAppSurveyItem.userDelegateKey == setValues.userDelegateKey &&
						delegateAppSurveyItem.buyerKey == setValues.buyerKey &&
						delegateAppSurveyItem.indirectBuyerKey == companyId){
							found = true;
					}
				})
			}
			if (found) {
				saveUserDelegateAppSurvey(action, setValues, completeCallback);
			} else {
				if (completeCallback) {
					completeCallback();
				}
			}
		} else if (completeCallback) {
			completeCallback();
		}
	};
	const saveUserDelegateAppSurvey = (action, setValues, completeCallback) => {
		let serverParams = {
			userDelegateSurveyKey: setValues.userDelegateSurveyKey,
			loginId: formValues.loginId,
			indirectBuyerKey: formValues.companyId,
			companyId: setValues.delegateCompanyId,
			buyerKey: setValues.buyerKey,
			userDelegateKey: setValues.userDelegateKey,
			level: setValues.level,
			appSurveyKey: setValues.appSurveyKey,
			surveyDelegateKey: setValues.surveyDelegateKey,
			canRead: setValues.canRead,
			canWrite: setValues.canWrite,
			canReview: setValues.canReview,
			source: "web",
			action: action
		};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};

		try {
			FetchUtil.fetchAPI("AddUpdateUserDelegateAppSurvey", "/Service/UserService/AddUpdateUserDelegateAppSurvey", requestOptions, saveDelegateAppSurveySuccess, saveDelegateAppSurveyFail, completeCallback);
		} catch (error) {
			setError(error.message);
			if (completeCallback) {
				completeCallback();
			}
		}
	};

	function saveDelegateAppSurveyFail(redirect, completeCallback) {
		setError(t("error.userAppSurveyEditFailed"));
		if (completeCallback) {
			completeCallback();
		}
	}
	function saveDelegateAppSurveySuccess(responseData, completeCallback) {
		let addUpdateUserDelegateAppSurveyResponse;
		if (responseData) {
			addUpdateUserDelegateAppSurveyResponse = responseData.addUpdateUserDelegateAppSurveyResponse;
			if (addUpdateUserDelegateAppSurveyResponse) {
				if (addUpdateUserDelegateAppSurveyResponse.errorCode === "0") {
					resetRowTable();
					refreshUserDelegateAppSurvey();
				} else {
					setError(t("error.error") + " " +
						addUpdateUserDelegateAppSurveyResponse.errorMessage
					);
				}
			}
		}
		if (completeCallback) {
			completeCallback();
		}
	}
	function refreshUserDelegateAppSurvey() {
		fetchUserDelegateAppSurveys();
	}
	return (
		<>
			{(userCtx.role === "SiteAdmin" || userCtx.role === "ClientAdmin") ?
				<div className="container-fluid container_list_sm viewh-85">
					<div className="row">
						<div className="col mt-3">
							{(error) ? (
								<div id="inerrorMessage" className="errorblock">
									{error}
								</div>
							) : (<></>)}
						</div>
						{( isUserDelegateAppSurveyLoading || isUserDelegateLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
					</div>
					<div className="row" style={{ margin: "0px" }}>
						<div className="col">
							<a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<div id="placeholder_1" className="placeholder-pg"></div>
						</div>
					</div>
					<div className="row">
						<div className="col">
							<table className="list-table" role="table">
								<thead>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.app.name")}</th>
										<th className="list-th">{t("page.survey.name")}</th>
										<th className="list-th">{t("page.read")}</th>
										<th className="list-th">{t("page.write")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
										<th className="list-th">{t("page.review")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</thead>
								<tbody role="rowgroup">
									{add && addRowTop &&
										<UserDelegateAppSurveyTableRow
											index={count}
											userDelegates={userDelegates}
											companyId={companyId}
											handleSubmit={handleSubmit}
											setErrorValue={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegateAppSurveys.length % 2) > 0) ? true : false} />
									}
									{(userDelegateAppSurveys.length > 0) ? (
										userDelegateAppSurveys.map((delegateAppSurveyItem, index) => (
											<UserDelagateAppSurveyReadOnlyRow
												index={count}
												t={t}
												delegateAppSurveyItem={delegateAppSurveyItem}
												handleDeleteClick={handleDeleteClick}
												setEdit={setEdit}
												oddIdx={((index % 2) > 0) ? true : false}
												setError={setError}
												handleSubmit={handleSubmit}
											/>
										))
									) : (<></>)}
									{add && addRowBottom &&
										<UserDelegateAppSurveyTableRow
											index={count}
											userDelegates={userDelegates}
											handleSubmit={handleSubmit}
											setError={setError}
											t={t}
											setAdd={setAdd}
											oddIdx={((userDelegateAppSurveys.length % 2) > 0) ? true : false} />
									}
								</tbody>
								{(userDelegateAppSurveys.length > 10) ? (<tfoot>
									<tr role="row">
										<th className="list-th">{t("header.admin.delegate")}</th>
										<th className="list-th">{t("page.app.name")}</th>
										<th className="list-th">{t("page.survey.name")}</th>
										<th className="list-th">{t("page.read")}</th>
										<th className="list-th">{t("page.write")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
										<th className="list-th">{t("page.review")}<span className="lbl-subtext">{t("page.active.not")}</span></th>
										<th className="list-th">{t("page.status")}</th>
										<th className="list-th" style={{ maxWidth: "9vw" }}>
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
												{t("page.addRow")}
											</button>&nbsp;&nbsp;
											<button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
												{t("page.delRow")}
											</button>
										</th>
									</tr>
								</tfoot>
								) : (<></>)}
							</table>
							<div className="row">
								<div className="col mt-3">
									{(error) ? (
										<div id="inerrorMessage1" className="errorblock">
											{error}
										</div>
									) : (<></>)}
								</div>
							</div>
							<div className="footer">
								<input
									type="button"
									name="edit-sub-appsurvey-close"
									id="edit-sub-appsurvey-close"
									className="btn btn-secondary btn-block" data-dismiss="modal"
									onClick={(e) => handleClose(e)}
									style={{ marginTop: "10px", marginBottom: "10px" }}
									value={closeText}
								></input>
							</div>
						</div>
					</div>
				</div>
				: null}
		</>
	);
}
export default UserDelegateAppSurveyTable;